import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import * as S from "./LeadGenButton.styles";
import LeadGenForm from "../LeadGenForm/LeadGenForm";
import LeadGenThankUForm from "../LeadGenThankU/LeadGenThankU";
import { submitQuerydetails } from "../../redux/thunks";
import { destinationSelector, sourceSelector, queryFieldsSelector,startDateSelector, seoInboundCallSelector, seoInboundContactNumber } from '../../redux/selector';
import {semDataSelector}  from './../../../../common/redux/selector';
import { pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { MOB_CAB_SEO_ASSISTED_FORM_SHOWN, LEAD_GEN_FORM, MOB_CAB_SEO_ASSISTED_FORM_SUBMITTED } from "../../../../../shared/utils/util-constants";
import { CTA_TYPE } from "../../../../../shared/utils/omni-utils";

const LeadGenButton = () => {
    const [haveQuery, setQuery] = useState(false);
    const [isFormSubmitted, setFormSubmit] = useState(false);
    const [content, setContent] = useState("");
    let timeId;
    const destCity = useSelector(destinationSelector).toUpperCase();
    const srcCity = useSelector(sourceSelector).toUpperCase();
    const startDate = useSelector(startDateSelector);
    const queryFields = useSelector(queryFieldsSelector);
    const semData = useSelector(semDataSelector);
    const showInboundCall = useSelector(seoInboundCallSelector)
    const contactNumber = useSelector(seoInboundContactNumber)
   
    const showQueryForm = () => {
        clearTimeout(timeId);
        setQuery(true);
    };

    const handleCloseQueryForm = () => {
        setQuery(false);
    }

    const handleClosethankYouForm = () => {
        setFormSubmit(false);
    }

    const handleSubmitFormData = (formData) => {
        setQuery(false);
        setFormSubmit(true);
        try {
            const res = submitQuerydetails(formData);
            res.then((result) => {
            const isError =  result?.error ? true : false;
            if(!isError){
                setContent("Thank You");
            }
            }).catch(() => {
                console.log('Error submitting lead gen query');
            })
        } catch(err) {
            console.log('Error submitting lead gen form');
        }
    }
     
    useEffect(() => {
        if(queryFields?.length > 0){
            timeId = setTimeout(showQueryForm, 60000);
            return () => {
                clearTimeout(timeId);
            }
        }
    }, []);

    useEffect(() => {
        if(haveQuery){
            pushCtaOmniEvents(MOB_CAB_SEO_ASSISTED_FORM_SHOWN, CTA_TYPE.HYPER_LINK, LEAD_GEN_FORM, window.location.href)
        }

        if (isFormSubmitted) {
            pushCtaOmniEvents(MOB_CAB_SEO_ASSISTED_FORM_SUBMITTED, CTA_TYPE.HYPER_LINK, LEAD_GEN_FORM, window.location.href)
        }
    }, [haveQuery, isFormSubmitted]);

    return (
        <>
            {
                haveQuery ? 
                    <LeadGenForm
                        source={srcCity}
                        destination={destCity}
                        onClose={ handleCloseQueryForm }
                        submitFormData={ handleSubmitFormData }
                        formfields={queryFields}
                        semData={semData}
                        startDate={startDate}
                        showInboundCall={showInboundCall}
                        contactNumber={contactNumber}
                    /> 
                :   null
            }
            {
                isFormSubmitted ? 
                    <LeadGenThankUForm
                        onClose={ handleClosethankYouForm }
                        content={ content }
                    /> 
                :   null
            }
            {
                queryFields?.length > 0 ? 
                    <S.ActionButtonsContainer onClick={()=> showQueryForm()}>
                        <ul className="buttonWrap">
                            <li className="buttonOption">
                                <span className="callBack"></span>
                                <span>Get A Call Back</span>
                            </li>
                        </ul>
                    </S.ActionButtonsContainer>
                : null
            }
        </>
    )
}

export default LeadGenButton